/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit PermittedToSeeInfo/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaCheckbox from 'DesignSystem/TysiaCheckbox/index'
import TysiaCheckboxInput from 'DesignSystem/TysiaCheckbox/TysiaCheckboxInput/index'
import TysiaCheckboxText from 'DesignSystem/TysiaCheckbox/TysiaCheckboxText/index'



/** @type {import('Simple/types.js').View} */
export default function PermittedToSeeInfo({
  children,
  viewPath = "/DesignSystem/DataVaxiomRelationshipsItem/Edit/Patient/Relationship/PermittedToSeeInfo",
  onChange
  
}) {
let editRelationPermittedToSeeInfoValueData = fromData.useDataValue({ viewPath,
context: 'edit_relation',
path: 'permitted_to_see_info',
})
let editRelationPermittedToSeeInfoChangeData = fromData.useDataChange({ viewPath,
context: 'edit_relation',
path: 'permitted_to_see_info',
})
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
  return (<React.Fragment
>
<TysiaCheckbox
  viewPath={`${viewPath}/TysiaCheckbox`}
 marginTop={dtSpaceS}
 data="edit_relation.permitted_to_see_info"
 value={editRelationPermittedToSeeInfoValueData}
 onChange={editRelationPermittedToSeeInfoChangeData}
>
{childProps => (
<React.Fragment>
<TysiaCheckboxInput
{...childProps}
  viewPath={`${viewPath}/TysiaCheckboxInput`}
/>
<TysiaCheckboxText
{...childProps}
  viewPath={`${viewPath}/TysiaCheckboxText`}
 text="Permitted to see patient info"
/>
</React.Fragment>
)}
</TysiaCheckbox>
{children}
</React.Fragment>)
}